import { Button } from 'react-bootstrap';
import { AssetSelect } from './AssetSelect';
import { ImageTypes } from './ImageViewerBody';


interface Props {
  onSelect: (id: string) => void; // Callback to handle the selection of a mission plan
  onSearch: React.MouseEventHandler; // Callback to run the mission plan
  ImageType: ImageTypes; // Current selection
  onChange: (checked: ImageTypes) => void; // Callback when selection changes
  currentAsset : string;
}

//@ts-ignore
export const ImageViewerControlBanner = ({
  onSelect,
  onSearch,
  ImageType,
  onChange,
  currentAsset,
}: Props) => {
  const handleRadioChange: React.ChangeEventHandler<HTMLInputElement> = (
    event
  ) => {
    onChange(event.target.value as ImageTypes);
  };

  return (
    <div className="mission-planning-banner p-3 mb-4 bg-white rounded">
      <span className="text-dark h5">Asset Picker</span>
      <AssetSelect onSelect={onSelect} />
        
      {(currentAsset !== '') && <div className="mt-2">
        <label className="me-3">
          <input
            type="radio"
            name="imageType"
            value=""
            checked={ImageType === ""}
            onChange={handleRadioChange}
          />
          Original
        </label>

        <label className="me-3">
          <input
            type="radio"
            name="imageType"
            value="WD"
            disabled={currentAsset === 'snapshot'}
            checked={ImageType === "WD"}
            onChange={handleRadioChange}
          />
          Wideshot
        </label>

        <label className="me-3">
          <input
            type="radio"
            name="imageType"
            value="THERMAL"
            checked={ImageType === "THERMAL"}
            onChange={handleRadioChange}
          />
          Thermal
        </label>

        <label className="me-3">
          <input
            type="radio"
            name="imageType"
            value="GAS"
            checked={ImageType === "GAS"}
            onChange={handleRadioChange}
          />
          Gas
        </label>
      </div>}

      <div className="d-flex mt-3">
        <Button variant="primary" onClick={onSearch} className="flex-fill me-2">
          Search
        </Button>
      </div>
    </div>
  );
};